<template>
  <div>
    <el-table
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-color"
      :data="post.result"
      border
    >
      <!-- .slice((currentPage - 1) * perPage, currentPage * perPage) -->
      <el-table-column label="Channel Name" min-width="150px" prop="title">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.channel.name }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Title" min-width="150px" prop="title">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.text }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Comments" min-width="130px" prop="totalComments">
        <template v-slot="{ row }">
          <span
            @click="showComments(row)"
            class="cursor-pointer text-black font-medium"
            >({{ row.totalComments }}) <span class="underline"> View </span>
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Likes" min-width="130px" prop="likes">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.totalLikes }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Reported" min-width="130px" prop="reported">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            row.isReported ? "Yes" : "No"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Date" min-width="130px" prop="date">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            new Date(row.createdAt).toLocaleDateString(undefined, {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })
          }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Uploaded By" min-width="170px" prop="postedBy">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            row._user ? row._user.firstname + " " + row._user.lastname : " "
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Actions"
        min-width="100px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        @change="handlePageChange"
        :total="post.totalCount"
      ></base-pagination>
    </b-card-footer>
  </div>
</template>
<script>
import { mapState } from "vuex";

import TagsData from "./TagsData";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      TagsData,
      userToggle: false,
      currentPage: 1,
      // post: [],
      total_row: 1,
      perPage: 5,
    };
  },
  methods: {
    handleDelete(info) {
      // console.log(info, "post");
      this.$swal({
        title: `Are you sure`,
        text: "Do you want to delete?",
        // buttonsStyling: false,
        showCancelButton: true,
        cancelButtonColor: "",
        confirmButtonClass: "btn btn-primary bg-primary",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: "YES",
        cancelButtonText: "No",
        icon: "warning",
      }).then(async (result) => {
        if (result.value) {
          // alert(this.currentPage);
          // this.dataload();
          this.$swal(
            "Deleted!",
            "Post has been successfully deleted",
            "success",
            "#4f0a4b"
          );
          await this.$store.dispatch("posts/admindeletePost", {
            _id: info.row._id,
          });
          let limit = 10;
          const offset = (this.currentPage - 1) * 10;
          await this.$store.dispatch("admin/getPost", {
            offset: offset,
            limit: limit,
          });
        }
      });
      this.dataload();
    },

    showComments(val) {
      try {
        this.$router.push({ name: "comments", query: { post: val._id } });
      } catch (error) {
        console.log(error);
      }
    },

    async dataload() {
      // let limit = this.perPage;
      // if ((this.currentPage - 1) * this.perPage > this.post.length)
      //   limit = this.currentPage * this.perPage - this.post.length;
      // const offset = this.post.length;
      // if (!this.post[this.currentPage * this.perPage - 1]) {
      //   let loader = this.$loading();
      //   try {
      //     const result = await this.$store.dispatch("admin/getPost", {
      //       offset: offset,
      //       limit: limit,
      //     });
      //     console.log(result.data, "*************");
      //     this.total_row = this.$store.state.admin.post.totalCount;
      //     this.$store.state.admin.post.result.forEach((data) => {
      //       this.post[this.post.length] = data;
      //     });
      //     this.post.push();
      //     loader.close();
      //   } catch (error) {
      //     loader.close();
      //   }
      // }
      try {
        let payload = {
          limit: 10,
          offset: (this.currentPage - 1) * 10,
        };
        await this.$store.dispatch("admin/getPost", payload);

        this.total_row = this.post.totalCount;
      } catch (error) {}
    },

    async handlePageChange(value) {
      this.currentPage = value;
      try {
        let payload = {
          limit: 10,
          offset: (this.currentPage - 1) * 10,
        };
        let result = await this.$store.dispatch("admin/getPost", payload);
        this.total_row = this.post.totalCount;
      } catch (error) {}
    },
  },

  computed: {
    ...mapState("channel", ["selectedChannel"]),
    ...mapState("admin", ["post"]),
  },
  mounted: function () {
    this.dataload();
  },
};
</script>
<style>
.swal2-confirm {
  background-color: #4f0a4b !important;
}
</style>
